export const calculateRating = (reputation: number): number => {
  return Math.round(reputation * 5 * 100) / 100
}
